import styled from 'styled-components';
import { Card } from 'antd';

export const darkTheme = {
  text: 'rgba(0,0,0,.85)',
  even: '#595959',
  odd: '#8c8c8c',
  hover: '#f5f5f5'
};

export const lightTheme = {
  text: 'black',
  even: '#7a8793',
  odd: '#bdc0c2',
  hover: '#dedede'
};

export const StyledCard = styled(Card)`
border: 1px solid #D3D3D3;
border-radius:20px;
margin-bottom: 10px;


box-shadow: 0 8px 6px -6px grey;

.ant-card-head {
    color:#000000 !important;
    border-bottom: 2px solid #d2caca;
    height: 65px;
}
.ant-card-body {
    color:#000000 !important;
    padding-left:0px
}`;

export const StyledElogbook = styled.div`
  margin: 45px 0px;
`;
